import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"fill-height",staticStyle:{"padding":"0"},attrs:{"fluid":""}},[_c('div',{staticClass:"cont"},_vm._l((_vm.tiles),function(row,i){return _c('div',{key:i,staticClass:"row"},_vm._l((row),function(tile,j){return _c('div',{key:j,staticClass:"main-el",staticStyle:{"padding":"0 !important"}},[_c('body-element',{attrs:{"tileIndex":{row: i, col: j}}})],1)}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }